import { GetLogger, LogLevel, logger, SetDefaultLogger } from "@pandas/logger";
import { servicesOrchestratorValues } from "@/config/services";
import { useStore } from "@/store";

SetDefaultLogger(
	GetLogger(
		servicesOrchestratorValues.environment,
		"webapp",
		servicesOrchestratorValues.credentials.axiom.token,
		servicesOrchestratorValues.credentials.axiom.orgId,
		servicesOrchestratorValues.credentials.axiom.dataset,
		LogLevel.trace,
	),
);

useStore.subscribe((state) => {
	logger.injectCommonProp("pandas_session_id", state.sessionId);
});

export function ChangeLoggerLevelFromConfig(minUploadLevel: string) {
	const levelEnum: LogLevel = LogLevel[minUploadLevel as keyof typeof LogLevel] ?? LogLevel.error;
	logger.changeLogLevel(levelEnum);
}

export default logger;
